import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { formatPrice } from "../lib/api";

const PLACEHOLDER =
  "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=900&q=80";

export default function ProductCard({ product, index = 0 }) {
  const img = (product.images && product.images[0]) || PLACEHOLDER;
  return (
    <Link
      to={`/product/${product.id}`}
      className="product-card block group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-image-wrap">
        <img src={img} alt={product.name} className="product-image" loading="lazy" />
        {product.featured && (
          <span className="absolute top-4 left-4 bg-[var(--mn-ink)] text-[var(--mn-bg)] text-[10px] uppercase tracking-[0.22em] px-2.5 py-1.5">
            Featured
          </span>
        )}
        {product.stock <= 0 && (
          <span className="absolute top-4 right-4 bg-[var(--mn-accent)] text-white text-[10px] uppercase tracking-[0.22em] px-2.5 py-1.5">
            Sold Out
          </span>
        )}
        {product.authenticator && (
          <span
            className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 bg-[var(--mn-bg)] text-[var(--mn-ink)] text-[10px] uppercase tracking-[0.22em] px-2.5 py-1.5 border border-[var(--mn-ink)]"
            data-testid={`card-authenticated-${product.id}`}
          >
            <BadgeCheck size={12} strokeWidth={1.6} />
            Authenticated
          </span>
        )}
      </div>
      <div className="pt-5 pb-2 flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow">{product.brand}</p>
          <h3 className="font-display text-xl md:text-2xl mt-1 leading-tight tracking-tight">
            {product.name}
          </h3>
          {product.color && (
            <p className="text-xs text-[var(--mn-ink-2)] mt-1 capitalize">{product.color}</p>
          )}
        </div>
        <div className="font-mono-luxe text-sm pt-2 whitespace-nowrap">
          {formatPrice(product.price)}
        </div>
      </div>
    </Link>
  );
}
